import React, {useEffect, useState} from 'react';
import {Form} from 'react-bootstrap';
import {getAhtapotOptions} from "../data";
import {Box} from "@material-ui/core";
import Typography from "@mui/material/Typography";
import {useCookies} from "react-cookie";

const AhtapotOptionsPanel = ({selectedOption, setSelectedOption}) => {
    const [cookies] = useCookies(['subscriptionToken']);
    const [acikDosyaAhtapotOtomatikTercihTipiOptions, setAcikDosyaAhtapotOtomatikTercihTipiOptions] = useState([]);
    const [kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiOptions, setKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiOptions] = useState([]);
    const [kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiOptions, setKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiOptions] = useState([]);

    const [selectedAcikDosyaAhtapotOtomatikTercihTipi, setSelectedAcikDosyaAhtapotOtomatikTercihTipi] = useState({});
    const [selectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi, setSelectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi] = useState({});
    const [selectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi, setSelectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi] = useState({});

    useEffect(() => {
        fetch(getAhtapotOptions,
        {
            headers: new Headers({'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)})
        })
            .then(response => response.json())
            .then(data => {
                setAcikDosyaAhtapotOtomatikTercihTipiOptions(data.acikDosyaAhtapotOtomatikTercihTipiList);
                setKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiOptions(data.kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiList);
                setKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiOptions(data.kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiList);

                const defaultAcikDosya = data.defaultAcikDosyaAhtapotOtomatikTercihTipi;
                const defaultKapaliTahsilatla = data.defaultKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi;
                const defaultKapaliYenilenebilir = data.defaultKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi;

                if (JSON.stringify(selectedAcikDosyaAhtapotOtomatikTercihTipi) === "{}") {
                    setSelectedAcikDosyaAhtapotOtomatikTercihTipi(defaultAcikDosya);
                }
                if (JSON.stringify(selectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi) === "{}") {
                    setSelectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi(defaultKapaliTahsilatla);
                }
                if (JSON.stringify(selectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi) === "{}") {
                    setSelectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi(defaultKapaliYenilenebilir);
                }

                if (!selectedOption) {
                    let ahtapotAbonelikAktiflestirmeDto = {
                        acikDosyaAhtapotOtomatikTercihTipiDto: defaultAcikDosya,
                        kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiDto: defaultKapaliTahsilatla,
                        kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiDto: defaultKapaliYenilenebilir
                    };
                    setSelectedOption(ahtapotAbonelikAktiflestirmeDto);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption, setSelectedOption]);

    const handleSelectChange1 = (event) => {
        const selectedValue = JSON.parse(event.target.value);
        setSelectedAcikDosyaAhtapotOtomatikTercihTipi(selectedValue);
        updateSelectedOption('acikDosyaAhtapotOtomatikTercihTipiDto', selectedValue);
    };

    const handleSelectChange2 = (event) => {
        const selectedValue = JSON.parse(event.target.value);
        setSelectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi(selectedValue);
        updateSelectedOption('kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiDto', selectedValue);
    };

    const handleSelectChange3 = (event) => {
        const selectedValue = JSON.parse(event.target.value);
        setSelectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi(selectedValue);
        updateSelectedOption('kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiDto', selectedValue);
    };

    const updateSelectedOption = (key, value) => {
        setSelectedOption(prevState => ({
            ...prevState,
            [key]: value
        }));
    };
    const styles = {
        formGroup: {
            fontFamily:'"Roboto", "Helvetica", "Arial", "sans-serif"',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '15px',
        },
        formLabel: {
            paddingLeft: 40,
            fontWeight: '400',
            flexBasis: '70%',
        },
        formSelect: {
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            fontSize: '14px',
            borderRadius: '4px',
            width: '30%',
            flexGrow: '1',
        },
        formControlFocus: {
            outline: 'none',
            borderColor: '#007bff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    };

    return (
        <Box style={{paddingLeft: 20, marginTop: 10, fontsize: 8}}
             maxWidth="md"
             fullWidth>
            <Typography component="div" gutterBottom style={{fontsize: 8, fontWeight: "bolder"}}>
                Ahtabot Atama Tercihleri;
            </Typography>
            <Form.Group controlId="formSelect1" style={styles.formGroup}>
                <Form.Label style={styles.formLabel}>
                    Ahtabot, En Son Açılmış Derdest Dosyalardan Başlayarak Otomatik Seçsin mi?
                </Form.Label>
                <Form.Control
                    as="select"
                    size="lg"
                    style={styles.formSelect}
                    value={JSON.stringify(selectedAcikDosyaAhtapotOtomatikTercihTipi)}
                    onChange={handleSelectChange1}
                >
                    {acikDosyaAhtapotOtomatikTercihTipiOptions.map(option => (
                        <option key={option.id} value={JSON.stringify(option)}>
                            {option.name}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Form.Group controlId="formSelect2" style={styles.formGroup}>
                <Form.Label style={styles.formLabel}>
                    Ahtabot, İnfaz Dosyalarda, Avans /Tahsilat Reddiyat Kontrolü İçin En Son Kapanmış Dosyalardan
                    Başlayarak Otomatik Seçsin mi?
                </Form.Label>
                <Form.Control
                    as="select"
                    size="lg"
                    style={styles.formSelect}
                    value={JSON.stringify(selectedKapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipi)}
                    onChange={handleSelectChange2}
                >
                    {kapaliTahsilatlaInfazDosyaAhtapotOtomatikTercihTipiOptions.map(option => (
                        <option key={option.id} value={JSON.stringify(option)}>
                            {option.name}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Form.Group controlId="formSelect3" style={styles.formGroup}>
                <Form.Label style={styles.formLabel}>
                    Ahtabot, Yenilenebilir Düşmüş Dosyaları, En Son Kapanmış Dosyalardan Başlayarak Otomatik Seçsin mi?
                </Form.Label>
                <Form.Control
                    as="select"
                    size="lg"
                    style={styles.formSelect}
                    value={JSON.stringify(selectedKapaliYenilenebilirDosyaAhtapotOtomatikTercihTipi)}
                    onChange={handleSelectChange3}
                >
                    {kapaliYenilenebilirDosyaAhtapotOtomatikTercihTipiOptions.map(option => (
                        <option key={option.id} value={JSON.stringify(option)}>
                            {option.name}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Box>
    );
};

export default AhtapotOptionsPanel;


